import { useEffect } from 'react';
import { apiFetch } from './api-client';
import { API_BASE } from './api-base';

/**
 * `TASK_VIEWED`, once per task shown (docs/smart-notifications-design.md §5.7) — web's twin of the
 * report both phones make when a task detail opens (iOS `TaskScreen.reportedViewedTaskId`, Android
 * `TaskScreen` `LaunchedEffect(id)`). It tells the ledger the person is looking at this task, so the
 * server need not nudge them about it.
 *
 * Mounted by BOTH task-detail entry points — the modal view model (`useTaskDetailModal`) and the
 * standalone `/tasks/[id]` page — so the two surfaces cannot drift. Once per task id per mount: a
 * re-render of the same detail is not a second viewing, but re-opening it is (the phones count the
 * same way). Best-effort like `useAppOpenSignal`: fire-and-forget, every failure swallowed; the route
 * itself answers 200 for a session with no Orion recipient yet.
 */
export function useTaskViewedSignal(taskId: string | undefined): void {
  useEffect(() => {
    if (typeof window === 'undefined' || !taskId) return;
    apiFetch(`${API_BASE}/api/client-signal`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ kind: 'taskViewed', taskId }),
      keepalive: true,
    }).catch(() => {});
  }, [taskId]);
}
